import { useTranslation } from 'react-i18next';
import {
    IconCalendarPerson,
    IconClockTable,
    IconHistory,
    IconScheduleTable,
} from '../../../../components/buttons/IconButtons';
import CustomCard from '../../../../components/CustomCard';
import dayId from '../../../../hooks/dayId';
import NotInformation from '../../../../components/NotInformation';
import CustomTooltip from "../../../../components/CustomTooltip";
import React from "react";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AccessRightsSection = ({ workShiftsList, customizedList }) => {
    const { t } = useTranslation();

    return (
         <>
            <div className='d-flex align-items-center'>
                <div>
                    <IconCalendarPerson className='h-16px w-16px' />
                </div>

                <p className='fs-14px font-color-general-950 ibl-font-w-600 ml-2'>
                    {t('work_shift')}
                </p>
            </div>
             <div className='border-bottom-shades-300 my-3' />
            {workShiftsList?.length > 0 ? (
                workShiftsList.map((item) => (
                    <CustomCard classContent='p-0' classes={'background-shades-100 border-radius-8px px-0 mb-3 '}>
                        <p className='fs-14px font-color-general-950 ibl-font-w-600 mb-3 mt-3 pl-3'>
                            {item?.name}
                        </p>
                    </CustomCard>
                ))
            ) : (
                <NotInformation
                    text={t('no_work_shift')}
                    card={true}
                />
            )}

            <div className='d-flex align-items-center mt-5'>
                <div>
                    <IconHistory className='h-16px w-16px' />
                </div>
                <p className='fs-14px font-color-general-950 ibl-font-w-600 ml-2'>
                    {t('custom_shift')}
                </p>
            </div>
             <div className='border-bottom-shades-300 my-3' />
            {customizedList?.length > 0 ? (
                customizedList.map((item) => (
                    <CustomCard classContent='p-3' classes='background-shades-100 border-radius-8px px-0 mb-3 '>
                        <div className='row align-items-center no-gutters'>
                            <div className='col-sm-12 col-md-7 col-lg-7 '>
                                <div className={"d-flex mr-2"}>
                                    <div className={"flex-grow-1 minw-0"}>
                                        <CustomTooltip
                                            text={item.zoneName}
                                            classes={`mb-0 fs-14px ibl-font-w-600 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                            placement={"top"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-5 col-lg-5'>
                                <div className={"d-flex justify-content-md-end"}>
                                    <div className={"d-flex align-items-center mr-5 flex-grow-1 minw-0"}>
                                        <div className={"d-flex justify-content-center mr-2"}>
                                            <IconScheduleTable className='icon-color-shades-600 w-16px' />
                                        </div>
                                        <CustomTooltip
                                            text={`${dayId(item.dayId ?? 1)}`}
                                            classes={`mb-0 fs-12px font-color-shades-600 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                            placement={"top"}
                                        />
                                    </div>
                                    <div className={"d-flex align-items-center flex-grow-1 minw-0"}>
                                        <div className={"d-flex justify-content-center mr-2"}>
                                            <IconClockTable className='icon-color-shades-600 w-16px' />
                                        </div>
                                        <div className={"flex-grow-1 minw-0"}>
                                            <CustomTooltip
                                                text={`${item.from} ${t('to').toLowerCase()} ${item.to}`}
                                                classes={`mb-0 fs-12px font-color-shades-600 text-ellipsis-1-row`}
                                                showIfTruncated={true}
                                                placement={"top"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CustomCard>
                ))
            ) : (
                <NotInformation
                    text={t('no_access_right')}
                    card={true}
                />
            )}
        </>
    );
};

export default AccessRightsSection;
